var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _ellipse, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangePassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 158,
    viewBox: "0 0 153 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 150C0 154.418 3.58172 158 8 158H145C149.418 158 153 154.418 153 150V65.6251C153 63.2351 151.931 60.9702 150.087 59.4505L149.019 58.5706L131.955 73.2573L77.9219 119.765L23.3197 74.4829L4.13223 58.5706L3.02635 59.4484C1.11444 60.9659 0 63.2734 0 65.7144V150Z",
    fill: "#555B68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9151 4.11348C80.0029 1.71431 75.8102 1.67621 72.8548 4.02205L50.2951 21.9288H104.541L82.9151 4.11348Z",
    fill: "#202329"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13223 58.5706L23.3197 74.4829V43.3405L4.13223 58.5706Z",
    fill: "#202329"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.955 73.2573L149.019 58.5706L131.955 44.5136V73.2573Z",
    fill: "#202329"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9219 119.765L131.955 73.2573V44.5136V25.9288C131.955 23.7197 130.165 21.9288 127.955 21.9288H104.541H50.2951H27.3197C25.1106 21.9288 23.3197 23.7197 23.3197 25.9288V43.3405V74.4829L77.9219 119.765Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41.625,
    y: 43.7031,
    width: 70.875,
    height: 4.48227,
    rx: 2.24113,
    fill: "#E8E8E8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41.625,
    y: 79.5625,
    width: 70.875,
    height: 4.48227,
    rx: 2.24113,
    fill: "#E8E8E8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.625,
    y: 61.6328,
    width: 70.875,
    height: 4.48227,
    rx: 2.24113,
    fill: "#E8E8E8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.5,
    cy: 107.581,
    rx: 31.9922,
    ry: 31.8661,
    fill: "#988DEA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7694 110.604L62 103C70.588 100.079 79.6117 98.6452 88.6821 98.7612C85.6897 107.325 81.2572 115.314 75.5757 122.386L71.7694 110.604ZM71.7694 110.604L79.0002 105.5",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePassword);
export default __webpack_public_path__ + "static/media/change-password.237b0ef6cd17dbe8a743cd7cb89af294.svg";
export { ForwardRef as ReactComponent };